module.exports = __webpack_public_path__ + "img/sun.8aabf61a.svg";